import { createGlobalStyle } from 'styled-components';
import { useSelector } from 'react-redux';
import { selectApiUrl, selectAppPersonalizations } from '../services/utils/appInfoSlice';
import { useEffect } from 'react';



const GlobalStyle = createGlobalStyle`
    ${({ fonts }) => {
        let templateLiteral = ``;
        fonts.forEach(f => {
            templateLiteral += `
                @font-face {
                    font-family: '${f.type}';
                    src: url('${f.font_url}') format('woff');
                    font-weight: ${f.weight};
                    font-style: normal;
                }
            `;
        });
        return templateLiteral;
    }}
`;

export default function GlobalFontStyle() {

    const personalizations = useSelector(selectAppPersonalizations);
    const API_URL = useSelector(selectApiUrl);
    const availableTypes = ['text', 'link', 'h1', 'h2', 'h3', 'primary_button', 'secondary_button']

    const mapFonts = () => {
        let fonts = []
        if(personalizations){
            availableTypes.forEach((type)=>{
                if(personalizations[type] && personalizations[type]?.font_url){
                    fonts.push({
                        font_url: `${API_URL}${personalizations[type]?.font_url}`,
                        type: `font_${type}`,
                        weight: type !== 'text' ? 700 : 500
                    })
                } else if (personalizations[type] && personalizations[type]?.text?.font_url) {
                    fonts.push({
                        font_url: `${API_URL}${personalizations[type]?.text?.font_url}`,
                        type: `font_${type}`,
                        weight: type !== 'text' ? 700 : 500
                    })
                }
            })
        }
        return fonts
    }


    return(
        <GlobalStyle fonts={mapFonts()} />
    )
}